import React, { Fragment, useContext, useEffect, useRef, useState, useCallback } from "react";
import Button from "../../../../lib/ui/buttons/Button";
import "../../../../ui-styles/search/Search.css";
import "../../../../ui-styles/list/CardsList.css";
import "../../../../ui-styles/list/FlatList.css";
import "../../../../ui-styles/sliders/RightFullSlider.css";
import "../../../../ui-styles/contentHeading/childHeading.css";
import { LangCtx, SignalerCtx } from "../../../../lib/context";
import { API } from "aws-amplify";
import AppointmentItem from "./appointmentItem";
import { appointmentList } from "../../../../actions/appointment";
import Loader from "../../../../lib/ui/loader/Loader";
import NoData from "../../../../lib/ui/nodata/NoData";
import { useHistory } from "react-router-dom";
import useDebounce from "../../useDebounce";
import { dateFormat } from "../../../../lib/functions";

const AppointmentsList = (props) => {
    const { signaler } = useContext(SignalerCtx);
    const history = useHistory();
    const { l } = useContext(LangCtx);
    const aptmntList = useRef(null);
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const searchRef = useRef("");
    const { role } = props;

    useEffect(() => {
        if (signaler) {
            signaler.on(`reload-appt-list`, (message) => {
                loadData();
            });
            return () => {
                signaler.off(`reload-appt-list`, () => {});
                // cancelListAPI();
            };
        }
    }, []);
    useEffect(() => {
        if (props.type) {
            setSearchTerm("");
            loadData();
        }
        // return () => {
        //     // cancelListAPI();
        // }
    }, [props.type]);
    

    useEffect(() => {
        if (searchRef.current !== searchTerm) {
            searchRef.current = searchTerm;
            loadData();
        }
        // return () => {
        //     cancelListAPI();
        // }
    }, [debouncedSearchTerm]);

    // const handleSerach = (e) => {

    //     let val = e.target.value.trim();
    //     if (val.length > 1 || val.length == 0) {
    //         let filter = val.toUpperCase();
    //         let li = aptmntList.current.getElementsByClassName('flGroup');
    //         //  let li = parent.getElementsByClassName('listAutoContent');
    //         let searchfound = false;
    //         for (let i = 0; i < li.length; i++) {
    //             let a = li[i].getElementsByClassName("userTxtL")[0];
    //             if (a) {
    //                 let txtValue = a.textContent || a.innerText;
    //                 if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //                     li[i].style.display = "";
    //                     searchfound = true;
    //                 } else {
    //                     li[i].style.display = "none";
    //                 }
    //             }
    //         }
    //     }
    // }

    const loadData = useCallback(() => {
        // if (props.type) {
        const { type } = props;
        setLoading(true);
        let from = new Date();
        let to = new Date();
        let status = null;
        let list_type = null;
        if (type === "UA") {
            list_type = "UA";
            to.setDate(to.getDate() + 30);
            status = ["confirmed", "pending"];
        } else if (type === "PA") {
            from.setDate(from.getDate() - 30);
            status = ["confirmed", "pending"];
            list_type = "PA";
        } else if (type === "CA") {
            from.setDate(from.getDate() - 30);
            to.setDate(to.getDate() + 30);
            status = ["rejected", "cancelled"];
        }

        let r = role === "C" ? "clinic" : "patient";
        let search = searchTerm !== "" ? searchTerm.replace(/\s/g, "") : "";
        appointmentList(r, status, from.valueOf(), to.valueOf(), list_type, search)
        .then((res) => {
                setLoading(false);
                if (res && res.status) {
                    let _data = {};

                    for (let i = 0; i < res.data.length; i++) {
                        let item = res.data[i];
                        let d = new Date(item.startTime);
                        d.setHours(0, 0, 0, 0);
                        let k = d.valueOf();
                        _data[k] ? _data[k].push(item) : (_data[k] = [item]);
                    }
                    setData(_data);
                } else {
                    setData([]);
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
                setData([]);
            });
        // }
    }, [props.type, searchTerm]);

    const handleBook = (e) => {
        e.preventDefault();
        history.push(role === "C" ? "/clinic-users" : "/doctor-booking");
    };

    let now = new Date();
    now.setHours(0, 0, 0, 0);
    return (
        <div className="listContainer pos-rel" ref={aptmntList}>
            {/* <div className= {overlayTrue ? "overlayDrop visibleShow" : "overlayDrop"}></div> */}
            <div className="searchBlock">
                <div className="searchBox searchFull">
                    <form method="post" className="searchForm" onSubmit={(e) => e.preventDefault()}>
                        <input
                            className="textbox"
                            title="Search"
                            value={searchTerm}
                            placeholder={l.search}
                            type="text"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </form>
                </div>
            </div>

            {loading && <Loader />}
            {data !== null && Object.keys(data) && Object.keys(data).length > 0 ? (
                // data.map(item => <AppointmentItem data={item} key={item.appointmentId} role={role} type={props.type} loadData={loadData} />)
                Object.keys(data)
                    .sort((a, b) => (a < b ? 1 : a > b ? -1 : 0))
                    .map((item) => (
                        <div className="cardBlock" key={item}>
                            <div className="dateBlock">
                                <h2 className="dateCurrent">
                                    {Number(now.valueOf()) === Number(item) ? l.today : dateFormat(Number(item))}
                                </h2>
                            </div>
                            <div className="cardContainer">
                                {data[item].map((_item) => (
                                    <AppointmentItem
                                        data={_item}
                                        key={_item.appointmentId}
                                        role={role}
                                        loadData={loadData}
                                        type={props.type}
                                    />
                                ))}
                            </div>
                        </div>
                    ))
            ) : props.type === "PA" && !loading ? (
                <Fragment>
                    <NoData Heading={l.no_appointments} src="/images/icons/pending-new.png" label="" />
                    <div className="rowBlock justifyCenter">
                        <div>
                            <Button
                                label={l.book_apptmnt}
                                className="btn"
                                size="sm"
                                fullWidth="fullWidth"
                                type="primary"
                                onClick={handleBook}
                            />
                        </div>
                    </div>
                </Fragment>
            ) : props.type === "UA" && !loading ? (
                <Fragment>
                    <NoData Heading={l.no_appointments} src="/images/icons/upcoming-new.png" label="" />
                    <div className="rowBlock justifyCenter">
                        <div>
                            <Button
                                label={l.book_apptmnt}
                                className="btn"
                                size="sm"
                                fullWidth="fullWidth"
                                type="primary"
                                onClick={handleBook}
                            />
                        </div>
                    </div>
                </Fragment>
            ) : (
                !loading && <NoData Heading={l.no_appointments} src="/images/icons/cancelled-new.png" label="" />
            )}
        </div>
    );
};

export default AppointmentsList;
